import { useGetMeContextQuery } from '@vizit/api';
import { useAuth } from '@vizit/auth';
import type { AccessContextValue } from '../types';

export function useAccessContext(): AccessContextValue {
  const { isAuthenticated, userId } = useAuth();

  const query = useGetMeContextQuery(userId, {
    enabled: !!isAuthenticated,
  });

  return {
    me: query.data,
    isLoading: query.isLoading,
    // An unauthenticated user counts as settled: the query never runs, so
    // there is no pending answer to wait for and no grants to read.
    isSettled: !isAuthenticated || query.isSuccess || query.isError,
  };
}
